import type { TConfigState } from '@/types/state-types'

export default <TConfigState>{
  unitsConfig: null,
}
